export class BaseResult {
    constructor(success, data, error) {
        if (success !== undefined)
            this.success = success;
        if (data)
            this.data = data;
        if (error)
            this.error = error;
    }
}
